import { AiAttachmentInfo } from '@euler/model/apdm';
import { memo, useState } from 'react';
import { AttachmentChip } from '../components/AttachmentChip';
import { AttachmentPreview } from './AttachmentPreview.web';

/** A sent attachment: a tap shows a spreadsheet in place, to read or save. */
export const OpenableAttachment = memo(
  ({ info }: { info: AiAttachmentInfo }) => {
    const [open, setOpen] = useState(false);
    // Images have no viewer here yet.
    const sheet = !info.mimeType.startsWith('image/');
    return (
      <>
        <AttachmentChip
          info={info}
          onOpen={sheet ? () => setOpen(true) : undefined}
        />
        {open && (
          <AttachmentPreview info={info} onClose={() => setOpen(false)} />
        )}
      </>
    );
  },
);
